import Vue from 'vue';
export default new Vue();

/**
 * 底部全局页面tab
 * globalTabIndex:当前选中的页面下标
 * globalTab：当前选中的页面名称
 *
 * 电站总览模块
 * curSideTabIndex:当前选中的侧边栏项的下标,用于控制侧边栏的显示
 * curSideTab:当前选中的侧边栏项的名称，用于控制不同界面的显示
 * showVideoModal:视频播放窗口显隐
 *
 * 故障诊断模块
 * warmFromIndex:是否来自于首页的故障列表点击，用于判断是否显示故障诊断页面右边列表
 *
 *
 * 智能巡检模块
 *
 *
 * 预警预演模块
 */
